import { LitElement, html, css } from 'lit'
import { customElement, property } from 'lit/decorators.js'
import { getPathPrefix } from './helpers/href'

@customElement('zaptic-no-reports-error')
export class NoReportsError extends LitElement {
    @property({ attribute: 'error-message' })
    errorMessage = ''

    static styles = css`
        :host {
            height: 100%;
            width: 100%;
        }

        .main-container {
            align-items: center;
            display: flex;
            flex-direction: column;
            height: 100%;
            justify-content: center;
            width: 100%;
        }

        .msg-container {
            margin: 1rem 0;
        }

        .msg-container span {
            color: var(--grey3);
            font: var(--font-mediu);
            font-size: var(--NoReportsError-font-size);
            font-style: normal;
            font-weight: var(--NoReportsError-font-weight);
            line-height: var(--NoReportsError-line-height);
        }
    `

    render() {
        const pathPrefix = getPathPrefix()

        return html`
            <div class="main-container">
                <div>
                    <object data="${pathPrefix}shared/images/zaptic-no-reports-error.svg" type="image/svg+xml"></object>
                </div>
                <div class="msg-container"><span>${this.errorMessage}</span></div>
            </div>
        `
    }
}
